<template>
    <swb-comn-seller-contract-list :contractType="contractType" :merchant="merchant" :path="path" :thisPath="thisPath" ref="swb_comn_seller_contract_list"></swb-comn-seller-contract-list>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import SwbRegisterServcDlgtContract from './RegisterServcDlgtContract';
    Routes.add(SwbRegisterServcDlgtContract);
    //
    import SwbComnSellerContractList from './ComnSellerContractList';
    Vue.regist(SwbComnSellerContractList);

    export default {
        name: 'swb-servc-dlgt-contract-list',
        path: '/servc/dlgt/contract/list',
        pathOld: '/servc/dlgt/contract/page/list',
        avlActions: '',
        avlActionNames: '添加合同、查看、编辑、申请审核、搜索标签、设置标签、站内信、作废、审核确认、变更、履约完成申请、申请验收、',
        avlScopes: 'servicer',
        desc: '服务授权合同',
        helpArticleCode: 'servicer-servc-dlgt-contract-list',
        data: function () {
            return {
                contractType: 6,
                merchant: '供应商',
                path: SwbRegisterServcDlgtContract.path,
                thisPath: Vue.$getClassInfo(this).path
            }
        },
        created: function () {
        },
        methods: {}
    }
</script>




// WEBPACK FOOTER //
// src/compo/contract/ServcDlgtContractList.vue